import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * This service communicates with backend to handle emploee's itrent data.
 */
@Injectable({
  providedIn: 'root'
})
export class EmployeeItrentService {
  private http = inject(HttpClient);

  url = environment.apiUrl + '/employees/itrent';

  synchronizePositions(): Observable<void> {
    const url = `${this.url}/positions`;
    return this.http.post<void>(url, {});
  }

  synchronizeAbsences(): Observable<void> {
    const url = `${this.url}/absences`;
    return this.http.post<void>(url, {});
  }

  synchronizeDailyPatterns(): Observable<void> {
    const url = `${this.url}/daily-patterns`;
    return this.http.post<void>(url, {});
  }

  synchronizeContractHours(): Observable<void> {
    const url = `${this.url}/contract-hours`;
    return this.http.post<void>(url, {});
  }
}
